let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bMvFz")).then(() => parcelRequire('9Hyki'));